<template>
  <regulation-item
    :regulationItemsProps="regulationItems"
    :destroyRegulationItemsProps="destroyRegulationItems"
    :editingRegulationBundler="editingRegulationBundler"
  >
  </regulation-item>
</template>
<script>
import RegulationItem from './RegulationItem'
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'

export default {
  components: { RegulationItem },
  data: () => {
    return {
      regulationItems: [],
      destroyRegulationItems: [],
      editingRegulationBundler: {}

    }
  },
  async mounted () {
    await this.fetchRegulation()
  },
  methods: {
    fetchRegulation () {
      axios.get(
        `/api/regulation_bundlers/${this.$route.params.id}/edit`
      )
        .then(
          ({ data }) => {
            if (deserialize(data).data.regulationItems) {
              let tmpArr = deserialize(data).data.regulationItems
              tmpArr.sort(function (a, b) {
                if (a.order < b.order) return -1
                if (a.order > b.order) return 1
              })
              this.regulationItems = tmpArr
            } else {
              this.regulationItems = []
            }
            this.editingRegulationBundler = deserialize(data).data
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.statusText.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    }
  }

}
</script>
